import "./FirstRow.css";
import useIsAuthorized from "../../Common/UI/hook/useIsAuthorized";
import { ReactElement, useEffect, useState } from "react";
import { NumberWidget } from "../../Common/UI/components/NumberWidget";
import { appRoles } from "../../authConfig";
import { FlexRow } from "../../Common/UI/components/FlexRow";
import { CardFreeInfo, WANStatuses, POSStatus, UberEats, DoorDash, DoorDashFeatureFlag } from "./Interfaces";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import CellTowerIcon from "@mui/icons-material/CellTower";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import useUserRoles from "../../Common/UI/hook/useUserRoles";

export const FirstRow = function ({
  loadingWANStatuses,
  WANStatuses,
  loadingCardFreeStatuses,
  cardFreeStatuses,
  loadingPOSStatuses,
  POSStatuses,
  loadingUberEatsStatuses,
  uberEatsStatuses,
  loadingDoorDashFeatureFlag,
  doorDashFeatureFlag,
  doorDashStatuses,
  loadingDoorDashStatuses,
}: {
  loadingWANStatuses: boolean;
  WANStatuses: WANStatuses[];
  loadingCardFreeStatuses: boolean;
  cardFreeStatuses: CardFreeInfo[];
  loadingPOSStatuses: boolean;
  POSStatuses: POSStatus[];
  loadingUberEatsStatuses: boolean;
  uberEatsStatuses: UberEats[];
  loadingDoorDashFeatureFlag: boolean;
  doorDashFeatureFlag: DoorDashFeatureFlag;
  doorDashStatuses: DoorDash[];
  loadingDoorDashStatuses: boolean;
}): ReactElement {
  const { roles, isLoading } = useUserRoles();
  const showFirewallStatus = useIsAuthorized([appRoles.Home.FirewallStatus], roles);
  const showOlo = useIsAuthorized([appRoles.Home.CardFreeStatus], roles);
  const showPOSStatus = useIsAuthorized([appRoles.Home.ViewPOSStatus], roles);
  const showUberEats = useIsAuthorized([appRoles.Home.ViewUberEatsStatus], roles);
  const showDoorDash = useIsAuthorized([appRoles.Home.ViewDoorDashStatus], roles);
  const showDoorDashFeatureFlag = useIsAuthorized([appRoles.Home.ViewDoorDashStatus], roles);

  const [posDate, setPOSDate] = useState<string | undefined>("");
  const [cfDate, setCFDate] = useState("");
  const [wanDate, setWANDate] = useState("");
  const [uberDate, setUberDate] = useState<string | undefined>("");
  const [doorDashDate, setDoorDashDate] = useState<string | undefined>("");

  const [storesDown, setStoresDown] = useState<number>(0);

  useEffect(() => {
    if (WANStatuses.length <= 0) return;

    const failedStores = WANStatuses.filter((x) => !x.status);
    setStoresDown(failedStores.length);
    setWANDate(WANStatuses[0].lastUpdated);
  }, [WANStatuses]);

  const [cardFreeDown, setCardFreeDown] = useState<number>(0);
  useEffect(() => {
    if (cardFreeStatuses.length <= 0) return;

    const failed = cardFreeStatuses.filter((x: CardFreeInfo) => x.status === false && x.isOutsideWorkingHours === false);
    setCardFreeDown(failed.length);

    setCFDate(cardFreeStatuses[0].lastUpdated);
  }, [cardFreeStatuses]);

  //const [POSDown, setPOSDown] = useState<number>(0);
  //useEffect(() => {
  //  if(POSStatuses.length <= 0)
  //    return;

  //  const failed = POSStatuses.filter((x) => x.activeDevices <= 0);
  //  setPOSDown(failed.length);

  //  setPOSDate(POSStatuses[0].lastUpdated);
  //}, [POSStatuses]);

  const [uberEatsNumber, setUberEatsNumber] = useState<number>(0);
  useEffect(() => {
    if (uberEatsStatuses.length == 0) return;

    const failed = uberEatsStatuses.filter((x: UberEats) => x.status === false && x.isOutsideWorkingHours === false);
    setUberEatsNumber(failed.length);

    setUberDate(uberEatsStatuses[0].lastUpdated);
  }, [uberEatsStatuses]);

  const [doorDashNumber, setDoorDashNumber] = useState<number>(0);
  useEffect(() => {
    if (doorDashStatuses.length == 0) return;

    const failed = doorDashStatuses.filter((x: DoorDash) => x.isActive === false && x.isOutsideWorkingHours === false);
    setDoorDashNumber(failed.length);

    setDoorDashDate(doorDashStatuses[0].lastUpdated);
  }, [doorDashStatuses]);

  return (
    <FlexRow>
      {showFirewallStatus && (
        <NumberWidget
          number={storesDown}
          isLoading={loadingWANStatuses}
          text="Network Offline"
          icon={<CellTowerIcon />}
          className="down-number"
          lastUpdatedDate={wanDate}
        ></NumberWidget>
      )}
      {showOlo && (
        <NumberWidget
          number={cardFreeDown}
          isLoading={loadingCardFreeStatuses}
          text="OLO Stores Offline"
          icon={<OnlinePredictionIcon fontSize="large" />}
          className="down-number"
          lastUpdatedDate={cfDate}
        ></NumberWidget>
      )}

      {showUberEats &&  (
        <NumberWidget
          number={uberEatsNumber}
          isLoading={loadingUberEatsStatuses}
          text="Uber Eats Stores Offline"
          icon={<DirectionsCarIcon fontSize="large" />}
          className="down-number"
          lastUpdatedDate={uberDate}
        ></NumberWidget>
      )}

      {showDoorDash && loadingDoorDashFeatureFlag == false && doorDashFeatureFlag.enabled && (
        <NumberWidget
          number={doorDashNumber}
          isLoading={loadingDoorDashStatuses}
          text="Door Dash Stores Offline"
          icon={<DirectionsCarIcon fontSize="large" />}
          className="down-number"
          lastUpdatedDate={doorDashDate}
        ></NumberWidget>
      )}
      {/* {showPOSStatus && (*/}
      {/*  <NumberWidget*/}
      {/*    number={POSDown}*/}
      {/*    isLoading={loadingPOSStatuses}*/}
      {/*    text="POS Terminals Offline"*/}
      {/*    icon={<MonitorIcon    fontSize="large" />}*/}
      {/*    className="down-number"*/}
      {/*    lastUpdatedDate={posDate}*/}
      {/*  ></NumberWidget>*/}
      {/*)}*/}
    </FlexRow>
  );
};
